import { getApiBaseUrlWithoutPath } from '../../config/environment';
import { extractAdminListTotal } from './adminListTotal';
import { ADMIN_LIST_PAGE_LIMIT } from './adminOrdersBulkFetch';

const MAX_PRODUCT_PAGES = 200;

/** Lightweight total from list API pagination (limit=1). */
export async function fetchAdminProductTotal(headers) {
  const apiUrl = getApiBaseUrlWithoutPath();
  const url = `${apiUrl}/api/admin/products?limit=1&page=1`;
  const response = await fetch(url, { method: 'GET', headers });
  if (!response.ok) return null;
  const payload = await response.json();
  return extractAdminListTotal(payload);
}

/** Load all admin product rows (paged) for stats / team filters when total exceeds first page. */
export async function fetchAllAdminProducts(headers) {
  const apiUrl = getApiBaseUrlWithoutPath();
  const all = [];
  let pagination = null;

  for (let page = 1; page <= MAX_PRODUCT_PAGES; page += 1) {
    const url = `${apiUrl}/api/admin/products?limit=${ADMIN_LIST_PAGE_LIMIT}&page=${page}`;
    const response = await fetch(url, { method: 'GET', headers });
    if (!response.ok) {
      throw new Error(`Products request failed (${response.status})`);
    }
    const result = await response.json();
    if (result.success === false) {
      throw new Error(result.message || result.error || 'Failed to load products');
    }
    const rows = Array.isArray(result.data) ? result.data : [];
    pagination = result.pagination ?? pagination;
    all.push(...rows);
    if (rows.length < ADMIN_LIST_PAGE_LIMIT) break;
    const totalPages = Number(pagination?.totalPages);
    if (Number.isFinite(totalPages) && totalPages > 0 && page >= totalPages) break;
  }

  return { products: all, pagination };
}

export { ADMIN_LIST_PAGE_LIMIT };
